/* ==========================================================================
   Global Footer JS
   Loaded on all pages (not gated by template suffix).
   Transforms footer navigation into collapsible accordions.
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
    // Tag the "Payment Options" footer column so CSS can hide it on desktop
    document.querySelectorAll('.footer-navigation .footer-column__heading').forEach(function (heading) {
        if (heading.textContent.trim() === 'Payment Options') {
            var column = heading.closest('.footer-column');
            if (column) column.classList.add('footer-column--payment-options');
        }
    });

    // Transform footer navigation menus into collapsible accordions
    // Always build the accordion DOM; CSS controls desktop (forced open) vs mobile (collapsible)
    var footerColumns = document.querySelectorAll('.footer-navigation .footer-column');
    footerColumns.forEach(function (column) {
        var heading = column.querySelector('.footer-column__heading');
        if (!heading) return;

        // Build <details>/<summary> wrapper
        var details = document.createElement('details');
        details.className = 'footer-accordion';

        var summary = document.createElement('summary');
        summary.className = 'footer-accordion__summary';
        summary.innerHTML =
            '<h6 class="footer-accordion__title">' + heading.textContent.trim() + '</h6>' +
            '<span class="footer-accordion__icon footer-accordion__icon--plus" aria-hidden="true">+</span>' +
            '<span class="footer-accordion__icon footer-accordion__icon--minus" aria-hidden="true">&minus;</span>';

        var content = document.createElement('div');
        content.className = 'footer-accordion__content';

        // Move all children except the heading into the content wrapper
        var children = Array.prototype.slice.call(column.children);
        children.forEach(function (child) {
            if (child !== heading) {
                content.appendChild(child);
            }
        });

        // Remove the original heading
        heading.remove();

        // Assemble and replace column contents
        details.appendChild(summary);
        details.appendChild(content);
        column.appendChild(details);
    });

    // Save references and insert placeholders so elements can be moved back
    var paymentBlock = document.querySelector('.footer-bottom .footer__payment');
    var paymentPlaceholder = null;
    if (paymentBlock) {
        paymentPlaceholder = document.createComment('payment-placeholder');
        paymentBlock.parentNode.insertBefore(paymentPlaceholder, paymentBlock);
    }
    var paymentAccordionContent = null;
    var allAccTitles = document.querySelectorAll('.footer-accordion__title');
    for (var i = 0; i < allAccTitles.length; i++) {
        if (allAccTitles[i].textContent.trim() === 'Payment Options') {
            var footerAccordion = allAccTitles[i].closest('.footer-accordion');
            if (footerAccordion) {
                paymentAccordionContent = footerAccordion.querySelector('.footer-accordion__content');
            }
            break;
        }
    }

    var footerBrand = document.querySelector('.footer-top .footer-brand');
    var footerMiddle = document.querySelector('.footer-middle');
    var brandPlaceholder = null;
    if (footerBrand) {
        brandPlaceholder = document.createComment('brand-placeholder');
        footerBrand.parentNode.insertBefore(brandPlaceholder, footerBrand);
    }

    // Prevent desktop summaries from toggling the accordion via click or keyboard
    function preventToggle(e) { e.preventDefault(); }
    var preventToggleAttached = new WeakSet();

    // Toggle footer accordions + move payment/brand based on viewport
    function updateFooterAccordions() {
        var accordions = document.querySelectorAll('.footer-accordion');
        var summaries = document.querySelectorAll('.footer-accordion__summary');
        if (window.innerWidth >= 750) {
            accordions.forEach(function (d) { d.setAttribute('open', ''); });
            // On desktop, summaries are non-interactive — remove from tab order and mark disabled
            summaries.forEach(function (s) {
                s.setAttribute('tabindex', '-1');
                s.setAttribute('aria-disabled', 'true');
                if (!preventToggleAttached.has(s)) {
                    s.addEventListener('click', preventToggle);
                    preventToggleAttached.add(s);
                }
            });
            // Move payment block back to original spot
            if (paymentBlock && paymentPlaceholder && paymentPlaceholder.parentNode) {
                paymentPlaceholder.parentNode.insertBefore(paymentBlock, paymentPlaceholder.nextSibling);
            }
            // Move brand back to original spot
            if (footerBrand && brandPlaceholder && brandPlaceholder.parentNode) {
                brandPlaceholder.parentNode.insertBefore(footerBrand, brandPlaceholder.nextSibling);
            }
        } else {
            accordions.forEach(function (d) { d.removeAttribute('open'); });
            // On mobile, summaries are interactive — restore tab order and remove disabled state
            summaries.forEach(function (s) {
                s.removeAttribute('tabindex');
                s.removeAttribute('aria-disabled');
                if (preventToggleAttached.has(s)) {
                    s.removeEventListener('click', preventToggle);
                    preventToggleAttached.delete(s);
                }
            });
            // Move payment block into accordion
            if (paymentBlock && paymentAccordionContent) {
                paymentAccordionContent.appendChild(paymentBlock);
            }
            // Move brand below accordion navigation
            if (footerBrand && footerMiddle) {
                footerMiddle.after(footerBrand);
            }
        }
    }
    updateFooterAccordions();
    window.addEventListener('resize', updateFooterAccordions);
});
